import React from "react";
import { TabSummary } from "./TabSummary";
import { TabIntroCall } from "./TabIntroCall";
import { TabConfirmationCall } from "./TabConfirmationCall";
import { TabInProgress } from "./TabInProgress";
import { TabInTransit } from "./TabInTransit";
import { TabDeliveryDay } from "./TabDeliveryDay";
import { TabPostMove } from "./TabPostMove";
import { TabNotesHub } from "./TabNotesHub";

/**
 * The job's sections, shared by the popup and the job page. Local and storage
 * jobs get 6; long distance gets 8 (In Progress (Local) and In Transit added).
 */
export const TAB_IDS = ["s1", "s2", "s3", "s3p", "s4t", "s4", "s5", "s6"];

export const buildTabs = (isLD) => {
  const tabs = [
    { id: "s1", label: "1 · Summary" },
    { id: "s2", label: "2 · Introduction Call" },
    { id: "s3", label: "3 · Confirmation Call" },
  ];
  if (isLD) tabs.push({ id: "s3p", label: `${tabs.length + 1} · In Progress (Local)` });
  if (isLD) tabs.push({ id: "s4t", label: `${tabs.length + 1} · In Transit` });
  tabs.push({
    id: "s4",
    label: isLD
      ? `${tabs.length + 1} · Delivery Day`
      : `${tabs.length + 1} · In Progress`,
  });
  tabs.push({ id: "s5", label: `${tabs.length + 1} · Post Move` });
  tabs.push({ id: "s6", label: `${tabs.length + 1} · Notes Hub` });
  return tabs;
};

export const JobTabBody = ({ tab, job, isLD, escalations, actions }) => {
  if (tab === "s1") return <TabSummary job={job} isLD={isLD} actions={actions} />;
  if (tab === "s2") return <TabIntroCall job={job} isLD={isLD} actions={actions} />;
  if (tab === "s3") return <TabConfirmationCall job={job} isLD={isLD} actions={actions} />;
  if (tab === "s3p") return <TabInProgress job={job} escalations={escalations} actions={actions} />;
  if (tab === "s4t") return <TabInTransit job={job} actions={actions} />;
  if (tab === "s4")
    return isLD ? (
      <TabDeliveryDay job={job} escalations={escalations} actions={actions} />
    ) : (
      <TabInProgress job={job} escalations={escalations} actions={actions} />
    );
  if (tab === "s5")
    return <TabPostMove job={job} isLD={isLD} escalations={escalations} actions={actions} />;
  return <TabNotesHub job={job} isLD={isLD} actions={actions} />;
};
